import { EditFileSelect, FileSelect } from '../../components';
import { CustomizedDxColumn } from './generateColumns';

export const setFileSelect = (dxColumn: CustomizedDxColumn) => {
	dxColumn.editCellComponent = EditFileSelect;
	dxColumn.cellComponent = FileSelect;
};
